/*
 * @Author: zyy
 * @Date: 2022-04-01 10:08:35
 * @LastEditors: zyy
 * @LastEditTime: 2022-04-02 19:22:19
 * @Description: default
 */
import Axios from "axios";
import Qs from 'qs'
import shopRequest from '@/io/shopRequest'
export default {
    // 添加分类
    add(name, remarks, status) {
        return Axios.post('/tsjy/api/admin/news/category/add', {
            name, remarks, status
        })
    },
    // 编辑分类
    edit(id, name, remarks, status) {
        return Axios.post(`/tsjy/api/admin/news/category/update/${id}`, {
            name, remarks, status
        })
    },
    // 删除
    delete(id) {
        return Axios.post(`/tsjy/api/admin/news/category/delete/${id}`)
    },
    // 更改状态
    status(id) {
        return Axios.post(`/tsjy/api/admin/news/category/setStatus/${id}`)
    },
    // 分类列表
    list(name, page) {
        return Axios.get('/tsjy/api/admin/news/category/list', {
            params: {
                page,
                name
            },
            paramsSerializer(params) {
                return Qs.stringify(params);
            }
        })
    },

}